// index.js
import allocations from './allocations.js';
import projectLedger from './project-ledger.js';
import projectTasks from './project-tasks.js';
import projectRoles from './project-roles.js';
import projectAssignments from './project-assignments.js';
import invoices from './invoices.js';
import invoiceLines from './invoice-lines.js';
import costs from './costs.js';
import expenseItems from './expense-items.js';
import projects from './projects.js';
import memberSkillAssignments from './member-skill-assignments.js';

const csvRules = {
  allocations,
  projectLedger,
  projectTasks,
  projectRoles,
  projectAssignments,
  invoices,
  invoiceLines,
  costs,
  expenseItems,
  projects,
  memberSkillAssignments,
};

const samplefiles = {
  allocations: 'allocations.csv',
  projectLedger: 'project-ledger.csv',
  projectTasks: 'project-tasks.csv',
  projectRoles: 'project-roles.csv',
  projectAssignments: 'project-assignments.csv',
  invoices: 'invoice-headers.csv',
  invoiceLines: 'invoice-lines.csv',
  costs: 'member-costs.csv',
  expenseItems: 'expense-items.csv',
  projects: 'projects.csv',
  memberSkillAssignments: 'memberSkillAssignments.csv',
};

// Per-type notices rendered above the file selector. Projects previously carried this in the
// (now removed) instructions panel; the V2 layout surfaces it above the file control instead.
const notices = {
  projects: 'Importing projects does not trigger email alerts.',
};

export default { csvRules, samplefiles, notices };
